import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputHeaderComponent } from './input-header.component';

@NgModule({
  declarations: [InputHeaderComponent],
  exports: [InputHeaderComponent],
  imports: [CommonModule],
})
export class InputHeaderModule {}
